export type SlackAuthorKind = 'user' | 'salesforce'

export type SlackMessage = {
  id: string
  author: string
  initials: string
  kind: SlackAuthorKind
  time: string
  text: string
}

export type SlackChannel = {
  name: string
  members: string[]
  messages: SlackMessage[]
}

/** Channels are provisioned per loan by the existing Salesforce ↔ Slack integration. */
export const slackChannels: Record<string, SlackChannel> = {
  'ln-1191': {
    name: 'ln-1191-whitfield',
    members: ['Milan R.', 'Handy N.', 'Renee P.', 'Salesforce'],
    messages: [
      {
        id: 's1',
        author: 'Salesforce',
        initials: 'SF',
        kind: 'salesforce',
        time: '9:04 AM',
        text: 'Loan LN-1191 created from application · Aaron Whitfield · $512,000 · FL',
      },
      {
        id: 's2',
        author: 'Salesforce',
        initials: 'SF',
        kind: 'salesforce',
        time: '9:12 AM',
        text: '2 borrower portal documents matched to conditions — awaiting LO review',
      },
      {
        id: 's3',
        author: 'Handy N.',
        initials: 'HN',
        kind: 'user',
        time: '9:26 AM',
        text: 'Picked this up. Ordering the credit report now — will flag anything odd.',
      },
      {
        id: 's4',
        author: 'Milan R.',
        initials: 'MR',
        kind: 'user',
        time: '9:31 AM',
        text: 'Thanks. Borrower is aiming for an Aug 28 close, so let’s keep intake tight this week.',
      },
    ],
  },
  'ln-1184': {
    name: 'ln-1184-cole',
    members: ['Milan R.', 'Handy N.', 'Salesforce'],
    messages: [
      {
        id: 's5',
        author: 'Salesforce',
        initials: 'SF',
        kind: 'salesforce',
        time: 'Yesterday',
        text: 'Stage changed: App Received → Credit & Pricing',
      },
      {
        id: 's6',
        author: 'Milan R.',
        initials: 'MR',
        kind: 'user',
        time: '8:10 AM',
        text: 'Sending pricing options this afternoon. Still need W-2s from the borrower.',
      },
    ],
  },
  'ln-1176': {
    name: 'ln-1176-lindqvist',
    members: ['Milan R.', 'Renee P.', 'Salesforce'],
    messages: [
      {
        id: 's7',
        author: 'Salesforce',
        initials: 'SF',
        kind: 'salesforce',
        time: '9 days ago',
        text: 'Stage changed: Conditions → Submitted to UW',
      },
      {
        id: 's8',
        author: 'Renee P.',
        initials: 'RP',
        kind: 'user',
        time: 'Monday',
        text: 'Still no decision from UW. Appraisal has not been ordered yet either.',
      },
      {
        id: 's9',
        author: 'Milan R.',
        initials: 'MR',
        kind: 'user',
        time: 'Tuesday',
        text: 'Escalating today — this file is 9 days in stage and the borrower is getting nervous.',
      },
    ],
  },
  'ln-1168': {
    name: 'ln-1168-price',
    members: ['Milan R.', 'Handy N.', 'Salesforce'],
    messages: [
      {
        id: 's10',
        author: 'Salesforce',
        initials: 'SF',
        kind: 'salesforce',
        time: 'Yesterday',
        text: 'Stage changed: Conditions → Clear to Close · closing Aug 4',
      },
      {
        id: 's11',
        author: 'Handy N.',
        initials: 'HN',
        kind: 'user',
        time: 'Yesterday',
        text: 'CD is out. Just need the closing time confirmed with title.',
      },
    ],
  },
  'ln-1155': {
    name: 'ln-1155-silva',
    members: ['Milan R.', 'Renee P.', 'Salesforce'],
    messages: [
      {
        id: 's12',
        author: 'Salesforce',
        initials: 'SF',
        kind: 'salesforce',
        time: '5:15 PM',
        text: 'Payoff statement uploaded via borrower portal — matched to “Updated payoff statement”',
      },
      {
        id: 's13',
        author: 'Milan R.',
        initials: 'MR',
        kind: 'user',
        time: '5:22 PM',
        text: 'Still waiting on the gift letter. Calling the borrowers back at 11:30 tomorrow.',
      },
    ],
  },
}
